'use client';

import { PageData } from '../../lib/pageData';
import { PropsWithChildren } from 'react';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';

type PageOwnerOrFitnessDataOnlyProps = {
  fitnessSettings: PageData['page']['stravaSettings'];
} & PropsWithChildren;

// This component is needed as the auth state can only be accessed client-side,
// but the StravaCard component needs to be rendered as a server component
export const PageOwnerOrFitnessDataOnly = ({
  children,
  fitnessSettings,
}: PageOwnerOrFitnessDataOnlyProps) => {
  const isPageOwner = useIsPageOwner();

  if (!isPageOwner && !fitnessSettings?.settings?.showTotaliser) {
    return null;
  }

  return <>{children}</>;
};
